import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class EducationService { 

    constructor(private http: HttpClient) { }

    geteducationService() {
        return this.http.get<any[]>(`${environment.apiUrl}get_education`);
    }    	    
}
